Object.defineProperties(Text.prototype, {
    toString: {
        value() { return this.data }
    },
    textContent: {
        get() { return this.data }
    }
});